import { Fragment } from "react";
import { StopCount } from "./stop-count";
import { twMerge } from "tailwind-merge";
import { IoFlag, IoLocationSharp } from "react-icons/io5";

type StopIconProps = {
  stop: number;
  stopsCount: number;
  className?: string;
};

export const StopIcon = ({
  stop,
  stopsCount,
  className,
}: StopIconProps): React.ReactElement => (
  <Fragment>
    {stop === 0 ? (
      <IoLocationSharp className={twMerge("text-4xl", className)} />
    ) : stop === stopsCount - 1 ? (
      <IoFlag className={twMerge("text-4xl", className)} />
    ) : (
      <StopCount stopNumber={stop} className={twMerge("h-8 w-8", className)} />
    )}
  </Fragment>
);
